import { makeStyles } from "@material-ui/core";
import React from "react";

import { IconInfoCircleFilled } from "@tabler/icons-react";
import { getTermType } from "../../util";

const useStyles = makeStyles(() => ({
  infoContainer: {
    padding: "1.5rem 2rem",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    display: "flex",
    flexDirection: "column",
    width: "50%",
    justifyContent: "center",

    "@media(max-width: 750px)": {
      width: "100%",
      order: 1,
    },
  },
  icon: {
    height: "35px",
    width: "35px",
    marginBottom: "1rem",
  },
  listWrapper: {
    padding: "5px",

    "& li": {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "0.5rem",

      "& span:nth-of-type(1)": {
        fontWeight: "600",
      },
    },
  },
}));

const InfoSection = ({
  data,
  status,
  subscriptionIsFinalized,
  paidCharges,
  nextPayment,
}) => {
  const classes = useStyles();

  const {
    subscriptionTermType,
    cancelledAt,
    charges,
    uniqueIdentifier,
    lastChargedAt,
    ticketArticleName,
    registrationFinalizedAt,
  } = data.subscriptionDetails;

  const termType = getTermType(subscriptionTermType, charges);

  return (
    <section className={classes.infoContainer}>
      <IconInfoCircleFilled className={classes.icon} />
      <ul className={classes.listWrapper}>
        {uniqueIdentifier && (
          <li>
            <span>Referensnummer</span>
            <span>{uniqueIdentifier}</span>
          </li>
        )}
        <li>
          <span>Status</span>
          <span>{subscriptionIsFinalized ? "Slutfört" : status}</span>
        </li>
        {registrationFinalizedAt && (
          <li>
            <span>Startdatum</span>
            <span>{registrationFinalizedAt}</span>
          </li>
        )}
        {cancelledAt && (
          <li>
            <span>Avbruten datum</span>
            <span>{cancelledAt}</span>
          </li>
        )}
        <li>
          <span>Abonnemangstyp</span>
          <span>{termType}</span>
        </li>
        <li>
          <span>Biljettnamn</span>
          <span>{ticketArticleName}</span>
        </li>
        {paidCharges.length > 0 && (
          <li>
            <span>Betalda dragningar</span>
            <span>
              {paidCharges.length}
              {subscriptionTermType === "FixedTerm" && ` av ${charges.length}`}
            </span>
          </li>
        )}
        {lastChargedAt && (
          <li>
            <span>Senaste dragningen</span>
            <span>{lastChargedAt}</span>
          </li>
        )}
        {nextPayment && (
          <li>
            <span>Nästa dragning</span>
            <span>{nextPayment}</span>
          </li>
        )}
      </ul>
    </section>
  );
};

export default InfoSection;
